import axios from 'axios'
import store from '@/store'
import { setToken } from '@/utils/tool.js'
import this_ from '../main.js'

let ipAddress = ''
let ipCity = ''
const ip = () => {
  axios.request({ url: 'http://ip-api.com/json', method: 'get' }).then(response => {
    if (response.status === 200 || response.data.status === '"success"') {
      ipAddress = response.data.query
      ipCity = `${response.data.regionName},${response.data.city}`
    }
  })
}
ip()
class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
    this.queue = {}
  }

  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl
    }
    return config
  }

  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      config.url += `?token=${store.getters.token}`
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      const timeStamp = new Date().getTime()
      config.headers = {
        clientId: store.getters.token,
        timeStamp: timeStamp,
        sign: 'not use',
        ipAddress: ipAddress,
        ipCity: encodeURI(ipCity, 'UTF-8')
      }
      this.queue[url] = true
      return config
    }, error => Promise.reject(error))
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data, status, msg } = res.data
      if (status !== 200) {
        if (status === 100) {
          store.dispatch('getUserInfo').then(response => {
            if (response.status === 200) {
              this_.$dialog.notify.success('权限更新成功!', { position: 'top-right', timeout: 4000 })
            }
          })
        } else if (status === 400) { // 登陆超时
          setToken('')
          window.location.reload()
        } else if (status === 403) { // 无权限
          if (data.show) {
            this_.$dialog.notify.error(data.msg, { position: 'top-right', timeout: 4000 })
          }
        } else {
          this_.$dialog.notify.error(msg, { position: 'top-right', timeout: 4000 })
        }
      }
      return { data, status }
    }, error => {
      console.log(error)
      this.destroy(url)
      this_.$dialog.notify.error('系统异常,请联系管理员', { position: 'top-right', timeout: 4000 })
      return {}
    })
  }

  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
